export function createPageLoadEvent (events) {
  return function pageLoadEvent (to, from) {
    const load = {
      to: to.name,
      from: from.name,
    };

    if (to.query && to.query.source) {
      load.source = to.query.source;
    }

    events.$emit(events.PAGE_LOAD, load);
  };
}
